// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

const isMigrationSubscriptionGroup = objectOf({
  id: string,
  name: maybe(string, true),
  app_group_id: maybe(string, true),
  app_group_name: maybe(string, true),
});

export const isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResult = objectOf({
  id: string,
  domain: string,
  status: string,
  type: string,
  provider: maybe(string, true),
  created_at: maybe(anyOf(number, nullOrUndefined)),
  expires_at: maybe(anyOf(number, nullOrUndefined)),
  expired_at: maybe(anyOf(number, nullOrUndefined)),
  dns_records: maybe(
    arrayOf(
      objectOf({
        type: string,
        name: string,
        value: string,
        status: string,
      })
    )
  ),
  available_migrations: maybe(
    arrayOf(
      objectOf({
        type: string,
        migratable: boolean,
      })
    )
  ),

  migrations: maybe(
    arrayOf(
      objectOf({
        type: string,
        state: string,
        step: string,
        subscription_groups: maybe(arrayOf(isMigrationSubscriptionGroup), true),
        remaining_subscription_groups: maybe(arrayOf(isMigrationSubscriptionGroup), true),
        dns_ttl: maybe(number, true),
      })
    ),
    true
  ),
});
